<template></template>
<script>
export default {
   data: function () {
    return {}
  },
  mounted: function() {
    this.loadPage();
  },
  methods: {
    loadPage() {
      var popUp = window.open('https://www.greyguardhealth.com/contact-us', 'contactus', 'width=800,height=800')
      if (popUp == null || typeof(popUp)=='undefined') {
        window.location.assign('https://www.greyguardhealth.com/contact-us')
      } else {
        popUp.focus()
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ContactUs.vue